import { useEffect, useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useUsEnv = () => {
  const [isUsEnv, setIsUsEnv] = useState(false);

  useEffect(() => {
    if (window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME) {
      setIsUsEnv(true);
    }
  }, []);

  return {
    isUsEnv,
  };
};
